import { render, staticRenderFns } from "./SimpleToolBar.vue?vue&type=template&id=3795b743"
import script from "./SimpleToolBar.vue?vue&type=script&lang=js"
export * from "./SimpleToolBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports